import createReactComponent from '../createReactComponent';
export default createReactComponent('refresh', 'IconRefresh', [
  ['path', { d: 'M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4', key: 'svg-0' }],
  ['path', { d: 'M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4', key: 'svg-1' }],
]);
